$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll-To
    // *
    // * Smooth-Scroll to targets on page
    // *
    // $('a[href*="#"]:not([href="#"])').click(function () {
    //     if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    //         var target = $(this.hash);
    //         target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    //         console.log(target)
    //         if (target.length) {
    //             scrollTo(target);
    //             return false;
    //         }
    //     }
    // });

    // function scrollTo(element) {
    //     $('html, body').animate({
    //         scrollTop: element.offset().top - 100
    //     }, 1000);
    // }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 60; // Distance from Browserbottom where the animation should start

    function fadeInElements() {
        var viewPort = $(window).scrollTop() + $(window).height();

        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top;

            if ((elementTop + offset) <= viewPort) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header
    // *
    // *

    // make white header dark after long sroll
    if ($(".js-header").length) {
        $(window).on("load scroll", function () {
            if ($(window).scrollTop() >= 100) {
                $(".js-header").addClass("collapse");
            }
            if ($(window).scrollTop() < 50) {
                $(".js-header").removeClass("collapse");
            };
        });
    };


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header language
    // *
    // *
    $(".js-header-language").click(function () {
        $(this).toggleClass("open");
    });

    $(".js-header-language").mouseleave(function () {
        if ($(this).hasClass("open")) {
            $(".js-header-language").removeClass("open");
        }
    })



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navSub
    // *
    // *
    $(".js-nav-item-parent > a").click(function (event) {

        // prevent tab from redirecting to url unless tab is active
        if (!$(this).parent("li").hasClass("open")) {
            event.preventDefault();
        }

        $(".js-header").addClass("open");
        $(".js-header-nav > ul > li.active").addClass("hideActive");
        $(this).parent(".js-nav-item-parent").addClass("open").removeClass("hideActive").siblings().removeClass("open");
    });

    $(".js-header-nav").mouseleave(function () {
        $(".js-nav-item-parent").removeClass("open");
        $(".js-header").removeClass("open");
        $(".js-header-nav > ul > li.active").removeClass("hideActive");
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navMobile
    // *
    // *
    $(".js-nav-button").click(function () {
        $(this).toggleClass("active");
        $(".js-nav-mobile").toggleClass("active");
        $(".js-header").toggleClass("open");
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            $(".js-nav-item-parent").removeClass("open");
            $(".js-header").removeClass("open");
            $(".js-header-nav > ul > li.active").removeClass("hideActive");
            $(".js-header-language").removeClass("open");
            $(".js-nav-mobile").removeClass("active");
            $(".js-nav-button").removeClass("active");

        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.each(function () {
            $(this).slick({
                fade: true,
                dots: true,
                infinite: true,
                arrows: false,
                accessibility: true,
                autoplay: true,
                autoplaySpeed: 2800,
                speed: 1000,
                customPaging: function (slider, i) {
                    return '<button class="button heroSlider__button">' + $(slider.$slides[i]).find('[data-title]').data('title') + '</button>';
                },
                responsive: [{
                    breakpoint: 600,
                    settings: {
                        customPaging: function (slider, i) {
                            return '<div class="heroSlider__dot"></div>';
                        },
                    }
                }]
            });
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $teaserGallery = $(".js-teaser-gallery");

    if ($teaserGallery.length) {
        $teaserGallery.each(function () {
            $(this).slick({
                fade: true,
                dots: false,
                infinite: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 500,
                speed: 0
            });
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * productTeaser loop
    // *
    // * Docs: https://github.com/scottalguire/grouploop
    var $productTeaser = $(".js-product-teaser");

    if ($productTeaser.length) {
        $productTeaser.grouploop({
            velocity: 0.5,
            forward: false,
            childNode: ".js-product-teaser-item",
            childWrapper: ".js-product-teaser-wrapper",
            pauseOnHover: true
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * slider
    // *
    var $slider = $(".js-slider");

    if ($slider.length) {
        $slider.each(function () {

            var $sliderWrapper = $(this).parents(".js-slider-wrapper");

            $(this).slick({
                infinite: true,
                fade: false,
                dots: false,
                arrows: true,
                autoplay: false,
                waitForAnimate: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: $sliderWrapper.find(".js-slider-nav-prev"),
                nextArrow: $sliderWrapper.find(".js-slider-nav-next"),
                draggable: false,
                rows: 0,
            });

            // set total
            var total = $(this).find(".slick-slide:not(.slick-cloned)").length;
            $sliderWrapper.find(".js-slider-total").html(total);

            // set description
            var desc = $sliderWrapper.find(".slick-slide:eq(1)").find(".js-slider-item-desc").html();
            $sliderWrapper.find(".js-slider-desc").html(desc);

            // set fullscreen
            var url = $sliderWrapper.find(".slick-slide:eq(1)").find(".js-slider-image").data("url");
            $sliderWrapper.find(".js-slider-fullscreen").attr("href", url);

            // set current number, description and fullscreen
            $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var desc = $sliderWrapper.find(".slick-slide:eq(" + (nextSlide + 1) + ")").find(".js-slider-item-desc").html(),
                    url = $sliderWrapper.find(".slick-slide:eq(" + (nextSlide + 1) + ")").find(".js-slider-image").data("url");
                $sliderWrapper.find(".js-slider-current").html(nextSlide + 1);
                $sliderWrapper.find(".js-slider-desc").html(desc);
                $sliderWrapper.find(".js-slider-fullscreen").attr("href", url);
            });
        });
    }

    // // formatting numbers to n digits: 1 => 01
    // function pad(n, width, z) {
    //     z = z || '0';
    //     n = n + '';
    //     return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    // }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * toggle button
    // *
    // *
    if ($(".js-toggle-content").length) {
        $(".js-toggle-button").click(function () {
            var index = $(this).index();
            $(this).addClass("active").siblings().removeClass("active");
            $(".js-toggle-content").eq(index).show().siblings().hide();
        });

        $(".js-toggle-button").eq(0).trigger("click");
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * $videoSlider
    // *
    // *
    // *
    var $videoSlider = $(".js-video-slider");

    if ($videoSlider.length) {
        $videoSlider.each(function () {

            var $sliderWrapper = $(this).parents(".js-video-slider-wrapper");

            $(this).slick({
                infinite: true,
                fade: false,
                dots: false,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 1000,
                waitForAnimate: false,
                prevArrow: $sliderWrapper.find(".js-video-slider-nav-prev"),
                nextArrow: $sliderWrapper.find(".js-video-slider-nav-next"),
            });
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * $ratingCarousel
    // *
    // *
    var $ratingCarousel = $(".js-rating-carousel");

    if ($ratingCarousel.length) {
        $ratingCarousel.each(function () {


            $(this).slick({
                infinite: true,
                fade: false,
                dots: false,
                arrows: false,
                waitForAnimate: false,
                variableWidth: true,
                draggable: false,
                rows: 0,
                speed: 9500,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
            });
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parse gallery
    // *
    // *
    if ($(".js-parse-gallery").length) {
        var galleryId = $(".js-parse-gallery").data("parse");
        $(".js-parse-gallery").find("a").attr("data-fancybox", galleryId);
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * asideTeaser
    // *
    // *
    $(".js-aside-teaser-button").on('click', function () {
        $(this).parents(".js-aside-teaser").toggleClass("collapse");
    })
    $(".js-aside-teaser-button").on('focusin', function () {
        if ($(this).is(':focus-visible')) {
            $(this).parents(".js-aside-teaser").toggleClass("collapse");
        }
    })

    if ($(".js-aside-teaser").length) {
        if ($(window).width() < 1400) {
            $(window).scroll(function () {
                var scroll = $(window).scrollTop();
                if (scroll > 600) {
                    $(".js-aside-teaser").addClass("collapse");
                }

                if (scroll < 500) {
                    $(".js-aside-teaser").removeClass("collapse");
                }
            });
        }
        else {
            $(window).scroll(function () {
                var scroll = $(window).scrollTop();
                if (scroll > 1100) {
                    $(".js-aside-teaser").addClass("collapse");
                }

                if (scroll < 1000) {
                    $(".js-aside-teaser").removeClass("collapse");
                }
            });
        }
    }





    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * product options
    // *
    // *

    $(".js-product-options").on("change", function () {
        var option = $(this).val(),
            $cover = $(".js-product-options-cover"),
            $coverLink = $(".js-product-options-coverlink"),
            $soldoutButton = $(".js-product-options-soldout"),
            $button = $(".js-cart-button"),
            image = $cover.data("cover-" + option),
            stock = $cover.data("stock-" + option),
            price = $(this).find(':selected').data("price");
        window.location.hash = option;

        // change price
        $(".js-product-price").html(price);

        // prevent sold items from add to cart
        if (stock <= 0) {
            $button.prop('disabled', true);
            $soldoutButton.fadeIn();
        } else {
            $button.prop('disabled', false);
            $soldoutButton.fadeOut();
        }

        $cover.attr("src", image);
        $coverLink.attr("href", image);
    });

    var hash = window.location.hash;

    if (hash.length && $(".js-product-options".length)) {
        var hash = hash.slice(1);
        $('.js-product-options').val(hash);
    }

    $(".js-product-options").trigger("change");

    function formatVariation(flag) {
        if (!flag.id) {
            return flag.text;
        }
        var baseUrl = "/assets/templates/web/img/";
        var $option = $(flag.element);
        var language = $option.data('language');

        if (language) {
            var $flag = $(
                '<span><img src="' + baseUrl + 'f-' + language + '.svg" class="productIntro__flag" /> ' + flag.text + '</span>'
            );
        } else {
            var $flag = flag.text;
        }
        return $flag;
    };

    $(".js-product-options").select2({
        templateResult: formatVariation,
        templateSelection: formatVariation,
        minimumResultsForSearch: -1
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * layout toggle
    // *
    // *
    $(".js-layout-toggle").click(function () {
        $(this).toggleClass("active").siblings(".js-layout-aside").slideToggle();
    })

    if ($(window).width() < 1050) {
        if ($(".js-layout-aside-shop li.active").length) {
            $(".js-layout-toggle").trigger("click");
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header bar
    // *
    // *
    var showHeaderBar = sessionStorage.getItem("headerbar");

    if (showHeaderBar != 1) {
        const browserLanguage = navigator.language;
        const siteLanguage = $("html").attr("lang");

        if (browserLanguage != siteLanguage) {
            $(".js-headerbar").fadeIn().addClass("active");
        }
    }

    $(".js-headerbar-close").click(function () {
        $(".js-headerbar").fadeOut().removeClass("active");
        sessionStorage.setItem("headerbar", 1);
    });

    $(".js-headerbar ul li a").click(function () {
        $(".js-headerbar").fadeOut().removeClass("active");
        sessionStorage.setItem("headerbar", 1);
    });





    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * eventForm
    // *
    // *
    $('.js-input-select').each(function () {
        var $select = $(this);

        function updateLabel() {
            if ($select.val()) {
                $select.removeClass('no-value');
                var index = $select.prop('selectedIndex');
                $('.js-eventform-images > *').eq(index).addClass("active").siblings().removeClass("active");
                console.log(index);
            } else {
                $select.addClass('no-value');
                $(".js-eventform-images *:nth-child(1)").addClass("active").siblings().removeClass("active");
            }
        }

        // Initial prüfen
        updateLabel();

        // Bei Auswahländerung
        $select.on('change', updateLabel);
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * filter project
    // *
    // *
    if ($(".js-filter-elements").length) {
        var mixer = mixitup(".js-filter-elements", {
            selectors: {
                target: '.js-filter-element'
            },
            load: {
                filter: '.all'
            }

        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * minicart
    // *
    // *
    $(".js-minicart-open").click(function () {
        showMiniCart();
    });

    $(".js-minicart-close").click(function () {
        hideMiniCart();
    });

    // close miniCart whenever user clicks outside minicart aside
    $(".js-minicart").on("click", function(e) {
        if ($(e.target).closest(".js-minicart-inner").length > 0) return; // Ignore click if click is inside minicart

        hideMiniCart();
    });

    function showMiniCart(showBadge = false) {
        $(".js-minicart").addClass("active");
        $(".js-minicart-badge").removeClass("active");

        if (showBadge) $(".js-minicart-badge").addClass("active");

        loadMiniCartProducts();
    }

    function hideMiniCart() {
        $(".js-minicart").removeClass("active");
        $(".js-minicart-badge").removeClass("active");
    }

    function loadMiniCartProducts() {
        $.ajax({
            url: "/assets/components/site/connector.php?action=getcart",
            type: "GET",
            data: { },
            success: function(response) {
                //console.log("Server antwortet:", response);

                // set products content
                $(".js-minicart-products").html(response.data.output);
                $(".js-minicart-total").html(response.data.total_formatted);

                if (response.data.total_quantity <= 0) {
                    $(".js-minicart").addClass("empty");
                }else {
                    $(".js-minicart").removeClass("empty");
                }
            },
            error: function(xhr) {
                console.error("Error:", xhr.responseText);
            }
        });
    }

    function updateMiniCartProduct(productId, quantity) {
        $.ajax({
            url: "/assets/components/site/connector.php?action=updatecartitem",
            type: "GET",
            data: { "id" : productId, "quantity" : quantity },
            success: function(response) {
                //console.log("Server antwortet:", response);

                // set data
                $(".js-header-cartnumber").html(response.data.order.total_quantity);

                // update cart
                loadMiniCartProducts();
            },
            error: function(xhr) {
                console.error("Error:", xhr.responseText);
            }
        });
    }

    // change quantity of an cart item
    $(document).on("change", ".js-minicart-quantity", function(){
        var productId = $(this).data("product"),
            quantity = $(this).val();

            updateMiniCartProduct(productId, quantity);
    });

    // remove item from cart
    $(document).on("click", ".js-minicart-remove", function(){
        var productId = $(this).data("product");

            updateMiniCartProduct(productId, 0);
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add to cart
    // *
    // *
    $(".js-addtocart-form").on("submit", function(e) {
        e.preventDefault();

        let formData = new FormData(this);

        $.ajax({
            url: "/assets/components/site/connector.php?action=addtocart",
            type: "POST",
            data: formData,
            processData: false,  // muss bei FormData auf false
            contentType: false,  // darf NICHT gesetzt werden
            success: function(response) {
                //console.log("Server antwortet:", response);

                // set data
                $(".js-minicart-cartlink").attr("href", response.data.url);
                $(".js-header-cartnumber").html(response.data.total_quantity);

                // show minicart
                showMiniCart(true);
            },
            error: function(xhr) {
                console.error("Error:", xhr.responseText);
            }
        });

        // trigger facebook tracking
        window.facebookTrackEventAddToCart();
    });








    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog sales
    // *
    // *
    $(".js-dialog-sales-open").click(function () {
        openSalesModal();
    })
    $(".js-dialog-sales-close").click(function () {
        closeSalesModal();
    })
    var $dialogSales = $(".js-dialog-sales");
    var dialogSalesState = sessionStorage.getItem('dialogSalesState');

    function openSalesModal() {
        $dialogSales.get(0).showModal();
        $("body").addClass("freeze");
    }

    function closeSalesModal() {
        $dialogSales.addClass("close");
        sessionStorage.setItem('dialogSalesState', true);
        $dialogSales.get(0).close();
        $("body").removeClass("freeze");
    }


    // backdrop click
    $(".js-dialog-sales").click(function (e) {
        if (e.target === e.currentTarget) {
            closeSalesModal();
        }
    });

    if (!dialogSalesState && $dialogSales.length > 0) {
        openSalesModal();
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog Newsletter
    // *
    // *
    $(".js-dialog-newsletter-open").click(function () {
        openNewsletterModal();
    })
    $(".js-dialog-newsletter-close").click(function () {
        closeNewsletterModal();
    })
    var $dialogNewsletter = $(".js-dialog-newsletter");
    var dialogNewsletterState = sessionStorage.getItem('dialogNewsletterState');

    function openNewsletterModal() {
        $dialogNewsletter.get(0).showModal();
        $("body").addClass("freeze");
    }

    function closeNewsletterModal() {
        $dialogNewsletter.addClass("close");
        sessionStorage.setItem('dialogNewsletterState', true);
        $dialogNewsletter.get(0).close();
        $("body").removeClass("freeze");
    }


    // backdrop click
    $(".js-dialog-newsletter").click(function (e) {
        if (e.target === e.currentTarget) {
            closeNewsletterModal();
        }
    });

    if (!dialogNewsletterState && $dialogNewsletter.length > 0) {
        openNewsletterModal();
    }

});


// * * * * * * * * * * * * * * * * * * * * * * * * *
// * scrollMover
// *
// *
function scrollMover() {
    var $window = $(window),
        viewPortStart = $window.scrollTop(),
        viewPortHeight = $window.height(),
        viewPortEnd = viewPortStart + viewPortHeight;

    var speedFactor = $(window).width() <= 700 ? 1.5 : 0.5;

    $(".js-scroll-mover").each(function () {
        var $track = $(this),
            $stage = $track.closest(".js-scroll-mover-stage"),

            stageTop = $stage.offset().top,
            stageHeight = $stage.outerHeight(),
            stageBottom = stageTop + stageHeight,

            trackWidth = $track.get(0).scrollWidth,
            stageWidth = $stage.outerWidth();

        // Track duplizieren, falls kleiner als Stage
        if (trackWidth <= stageWidth) {
            var originalHTML = $track.html();
            while ($track.get(0).scrollWidth <= stageWidth * 1.5) {
                $track.append(originalHTML);
            }
            trackWidth = $track.get(0).scrollWidth; // neu berechnen
        }

        if (trackWidth <= stageWidth) {
            $track.css("transform", "translateX(0)");
            return;
        }

        var isVisible = stageBottom > viewPortStart && stageTop < viewPortEnd;
        if (!isVisible) {
            $track.css("transform", "");
            return;
        }

        var animationStart = stageTop - viewPortHeight;
        var animationEnd = stageBottom;

        var progress = (viewPortStart - animationStart) / (animationEnd - animationStart);
        progress = Math.min(Math.max(progress, 0), 1);

        // Geschwindigkeit anpassen
        progress *= speedFactor;

        var maxTranslateX = trackWidth - stageWidth;
        var reverse = $track.is("[data-scroll-mover-reverse]");

        var translateX = reverse
            ? -(1 - progress) * maxTranslateX
            : -progress * maxTranslateX;

        $track.css({
            transform: `translateX(${translateX}px)`
        });
    });
}

// Scroll & Resize Listener
$(window).on("scroll resize", scrollMover);

// Initial aufrufen
scrollMover();



// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sliderVertical
// *
// *
if ($('.js-slidervertical').length) {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    function throttle(func, limit) {
        let inThrottle;
        return function () {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        }
    }

    $(document).ready(function () {
        $('html, body').scrollTop(0);

        $('.js-slidervertical').each(function () {
            const $slider = $(this);
            const $slides = $slider.find('.js-slidervertical-slide');
            const $dotsNav = $slider.find('.sliderVertical__dots');
            if (!$slides.length) return;

            let slideOffsets = [];

            function getHeaderHeight() {
                return $(window).width() < 1350 ? 80 : 100;
            }

            function calculateSlideOffsets() {
                const headerHeight = getHeaderHeight();

                $slides.addClass('relative');

                slideOffsets = []; // Array zurücksetzen

                $slides.each(function () {
                    slideOffsets.push(Math.round($(this).offset().top) - headerHeight);
                });

                $slides.removeClass('relative');

                // console.log("Final Offsets: ", slideOffsets);
            }

            function updateActive() {
                const scrollTop = $(window).scrollTop();
                const activationPoint = scrollTop + ($(window).height() * 0.5);
                let activeIndex = -1;

                $slides.each(function (i) {
                    if (activationPoint >= slideOffsets[i] - 5) {
                        activeIndex = i;
                    }
                });

                $slides.removeClass('active').eq(activeIndex).addClass('active');
                const $buttons = $dotsNav.find('.js-slidervertical-button');
                $buttons.removeClass('active').eq(activeIndex).addClass('active');

                if (activeIndex >= 0 && $slides.eq(activeIndex).hasClass('white')) {
                    $dotsNav.addClass('white');
                } else {
                    $dotsNav.removeClass('white');
                }
            }

            function toggleDotsVisibility() {
                const rect = $slider[0].getBoundingClientRect();
                const winH = $(window).height();
                const visibleHeight = Math.min(rect.bottom, winH) - Math.max(rect.top, 0);
                const visibleRatio = visibleHeight / winH;

                if (visibleRatio >= 0.7) {
                    $dotsNav.css({ 'opacity': 1, 'pointer-events': 'auto' });
                } else {
                    $dotsNav.css({ 'opacity': 0, 'pointer-events': 'none' });
                }
            }

            $dotsNav.empty();
            $slides.each(function (i) {
                const id = $(this).attr('id');
                const $btn = $('<button/>', {
                    type: 'button',
                    class: 'sliderVertical__button js-slidervertical-button',
                    'data-target': id
                });
                if (i === 0) $btn.addClass('active');
                $dotsNav.append($btn);
            });

            const $buttons = $dotsNav.find('.js-slidervertical-button');

            $buttons.on('click', function () {
                const targetId = $(this).data('target');
                const $targetSlide = $('#' + targetId);
                const targetIndex = $slides.index($targetSlide);
                if (targetIndex !== -1) {
                    $('html, body').stop(true, true).animate({
                        scrollTop: slideOffsets[targetIndex]
                    }, 300);
                }
            });

            // Video Sound Mute/Unmute Toggle
            $slider.find('.sliderVertical__mediaWrapper').each(function () {
                const $wrapper = $(this);
                const $video = $wrapper.find('.js-slidervertical-video');
                const $unmuteBtn = $wrapper.find('.js-slidervertical-video-unmute');
                const $muteBtn = $wrapper.find('.js-slidervertical-video-mute');

                if ($video.length) {
                    const isMuted = $video.prop('muted') || ($video[0] && $video[0].muted);
                    if (isMuted) {
                        $unmuteBtn.show().addClass('active');
                        $muteBtn.hide().removeClass('active');
                    } else {
                        $unmuteBtn.hide().removeClass('active');
                        $muteBtn.show().addClass('active');
                    }
                }
            });

            $slider.on('click', '.js-slidervertical-video-unmute', function (e) {
                e.preventDefault();
                const $unmuteBtn = $(this);
                const $wrapper = $unmuteBtn.closest('.sliderVertical__mediaWrapper');
                const $video = $wrapper.find('.js-slidervertical-video');
                if ($video.length) {
                    const videoEl = $video[0];
                    videoEl.muted = false;
                    $video.prop('muted', false);
                    if (videoEl.paused) {
                        videoEl.play();
                    }
                    $unmuteBtn.hide().removeClass('active');
                    $wrapper.find('.js-slidervertical-video-mute').show().addClass('active');
                }
            });

            $slider.on('click', '.js-slidervertical-video-mute', function (e) {
                e.preventDefault();
                const $muteBtn = $(this);
                const $wrapper = $muteBtn.closest('.sliderVertical__mediaWrapper');
                const $video = $wrapper.find('.js-slidervertical-video');
                if ($video.length) {
                    const videoEl = $video[0];
                    videoEl.muted = true;
                    $video.prop('muted', true);
                    $muteBtn.hide().removeClass('active');
                    $wrapper.find('.js-slidervertical-video-unmute').show().addClass('active');
                }
            });

            function initSliderVerticalCarousels() {
                $slider.find(".js-slidervertical-carousel").each(function () {
                    const $carousel = $(this);
                    const count = $carousel.find(".sliderVertical__videosItem").length;

                    if (count === 0) return;

                    if (!$carousel.hasClass("slick-initialized")) {
                        $carousel.slick({
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: false,
                            dots: false,
                            arrows: true,
                            prevArrow: $carousel
                                .parent()
                                .find(".js-slidervertical-carousel-prev"),
                            nextArrow: $carousel
                                .parent()
                                .find(".js-slidervertical-carousel-next"),
                            responsive: [
                                {
                                    breakpoint: 1000,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 1,
                                    },
                                },
                                {
                                    breakpoint: 500,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                    },
                                },
                            ],
                        });
                    }

                    // Set class to center track if there are fewer slides than slidesToShow
                    const width = $(window).width();
                    let slidesToShow = 3;
                    if (width <= 500) {
                        slidesToShow = 1;
                    } else if (width <= 1000) {
                        slidesToShow = 2;
                    }

                    if (count <= slidesToShow) {
                        $carousel.addClass("slick-no-scroll");
                    } else {
                        $carousel.removeClass("slick-no-scroll");
                    }
                });
            }

            function initializeSliderState() {
                setTimeout(function () {
                    calculateSlideOffsets();
                    updateActive();
                    toggleDotsVisibility();
                    initSliderVerticalCarousels();
                }, 250);
            }

            $(window).on('load', initializeSliderState);

            $(window).on('scroll', throttle(function () {
                updateActive();
                toggleDotsVisibility();
            }, 100));

            $(window).on('resize', throttle(function () {
                calculateSlideOffsets();
                updateActive();
                toggleDotsVisibility();
                initSliderVerticalCarousels();
            }, 150));
        });
    });
}

